import BaseRepository from '@/repositories/base/BaseRepository';

class MarketRepository extends BaseRepository {
  // cpt钱包可用余额
  getCptWalletInfo() {
    return this.post<any>({
      url: '/ebk-dkb-api/wallet/getCptWalletInfo',
      data: {},
    });
  }


  //精准营销-产品申购页关联关系
  createOrderCheck(params: any) {
    return this.get<any>({
      url: '/ebk-dkb-api/market/createOrderCheck',
      data: params,
    });
  }
  
  //精准营销-创建
  createOrder(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/market/createOrder',
      data: params,
    });
  }
  
   //精准营销-订单列表
   getOrderList(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/market/getOrderList',
      data: params,
    });
  }

  //精准营销-结束活动
  updateMarketOrder(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/market/updateMarketOrder',
      data: params,
    });
  }

  //精准营销-订单操作记录
  getSmsMarketOrderLogs(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/market/getSmsMarketOrderLogs',
      data: params,
    });
  }

  //精准营销-订单详情
  getOrderDetail(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/market/getOrderDetail',
      data: params,
    });
  }
  
  //精准营销活动id
  getActivityIds() {
    return this.post<any>({
      url: '/ebk-dkb-api/market/getActivityIds',
      data: {},
    });
  }

  //精准营销-营销数据概览
  getSmsMarketDataOverview(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/market/getSmsMarketDataOverview',
      data: params,
    });
  }

  //精准营销-营销折线图数据
  getSmsMarketLineChartData(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/market/getSmsMarketLineChartData',
      data: params,
    });
  } 
  
  //CPT钱包支付
  cptAccountBalance(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/extension/cptAccountBalance',
      data: params,
    });
  } 

  
}

export default MarketRepository;
